import { type ReactNode, cloneElement, isValidElement } from "react";
import type { Role } from "@avestate/shared";
import { useAuth } from "@/auth/useAuth.js";
import { hasRole } from "@/lib/role.js";

type Props = {
  min: Role;
  children: ReactNode;
  /** When true and role insufficient, render the child as disabled instead of hiding it. */
  asDisabled?: boolean;
  /** Optional explicit fallback when child is hidden. */
  fallback?: ReactNode;
};

export function RoleGate({ min, children, asDisabled = false, fallback = null }: Props): JSX.Element | null {
  const { role } = useAuth();
  const allowed = hasRole(role, min);

  if (allowed) return <>{children}</>;
  if (!asDisabled) return <>{fallback}</>;

  if (isValidElement(children)) {
    // Inject `disabled` and `aria-disabled` into the single child element.
    return cloneElement(children as React.ReactElement<{ disabled?: boolean; "aria-disabled"?: boolean; title?: string }>, {
      disabled: true,
      "aria-disabled": true,
      title: `Richiede ruolo >= ${min}`,
    });
  }
  return <>{fallback}</>;
}
